// @flow strict
const PAGINATION = {
  PREV_PAGE: '← ANT',
  NEXT_PAGE: '→ SIG'
};

export default PAGINATION;
